

const Footer = ()=>{
    return(
        <>
        <div className="footer">
            Copyright - {new Date().getFullYear()} All Rights Reserved.
        </div>
        </>
    )
}


export default Footer